import { render, staticRenderFns } from "./PlanCardV2.vue?vue&type=template&id=7dcf964c&scoped=true&"
import script from "./PlanCardV2.vue?vue&type=script&lang=ts&"
export * from "./PlanCardV2.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCardV2.vue?vue&type=style&index=0&id=7dcf964c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf964c",
  null
  
)

export default component.exports